<div class="px-3 pt-2 pb-2">
  <div class="catalog-tree-filter-header">
    <dx-text-box class="catalog-tree-search"
                 mode="search"
                 [showClearButton]="true"
                 placeholder="{{ 'Produkte suchen' | translate }}"
                 [value]="searchText"
                 (onInput)="onSearchInputInternal($event)"
                 (onValueChanged)="onSearchTextChanged($event.value)">
    </dx-text-box>

    <dx-button class="dx-button-text-left"
               text="{{ 'Erweitert' | translate }}"
               type="default"
               stylingMode="text"
               (onClick)="toggleFilter()"
               [icon]="showFilter ? 'chevrondown' : 'chevronleft'">
    </dx-button>
  </div>
</div>

<div *ngIf="showFilter" class="px-3 pb-2">
  <dx-tabs *ngIf="filterTabs.length > 1"
           class="np-clean-tabs"
           [dataSource]="filterTabs"
           [selectedIndex]="activeFilterTabIndex"
           [scrollByContent]="false"
           [showNavButtons]="false"
           (onItemClick)="onFilterTabChanged($event.itemIndex)">
  </dx-tabs>

  <div [hidden]="activeFilterTabIndex !== 0" class="pt-2">
    <productStateOptions *ngIf="showProductStateOptions"
                         [stateValue]="stateValue"
                         [isTarget]="isTargetFilter"
                         (onValueChanged)="updateState($event)">
    </productStateOptions>
    <productSearchOptions [isTarget]="isTargetFilter"
                          (onValueChanged)="updateSearchFields($event)">
    </productSearchOptions>
  </div>

  <div *ngIf="showSearchFormTab" [hidden]="activeFilterTabIndex !== 1" class="pt-2">
    <searchFormOptions
        [catalogId]="catalogId"
        [refreshWithSearchForm]="refreshWithSearchForm"
        [syncWithService]="syncSearchFormWithService"
        (onEditSearchForm)="onEditSearchForm.emit($event)"
        (onExecuteSearchForm)="executeSearchFormInternal($event)">
    </searchFormOptions>
  </div>
</div>

<div class="catalog-tree-container">
  <dx-tree-list class="tree"
                [dataSource]="dataSource"
                [showBorders]="false"
                [showColumnHeaders]="false"
                [showColumnLines]="false"
                [showRowLines]="false"
                [rowAlternationEnabled]="true"
                [hoverStateEnabled]="true"
                [remoteOperations]="{ filtering: true }"
                keyExpr="treeElementId"
                parentIdExpr="parent"
                hasItemsExpr="hasChilds"
                rootValue="0"
                [(selectedRowKeys)]="selectedRowKeys"
                (onSelectedRowKeysChange)="onSelectedRowKeysChanged($event)"
                (onSelectionChanged)="onSelectionChanged.emit($event)"
                (onRowClick)="onRowClick.emit($event)"
                (onCellPrepared)="onCellPreparedInternal($event)"
                (onContentReady)="onContentReady.emit($event)"
                (onInitialized)="onInitialized.emit($event)">

    <dxo-search-panel [visible]="false"
                      [(text)]="searchText"
                      placeholder="{{ 'Produkte suchen' | translate }}"
                      width="auto">
    </dxo-search-panel>

    <dxo-scrolling mode="virtual" showScrollbar="always"></dxo-scrolling>

    <dxo-selection [mode]="selectionMode"
                   [recursive]="selectionRecursive"
                   [allowSelectAll]="selectionAllowSelectAll">
    </dxo-selection>

    <dxo-row-dragging *ngIf="dragGroup"
                      [group]="dragGroup"
                      [onDragStart]="onDragStartFn"
                      [onAdd]="onDropFn"
                      [allowDropInsideItem]="allowDropInsideItem"
                      [allowReordering]="allowReordering"
                      [showDragIcons]="showDragIcons">
    </dxo-row-dragging>

    <dxi-column dataField="Title" cellTemplate="cellTemplate"></dxi-column>
    <dxi-column dataField="order" [visible]="false" sortOrder="asc"></dxi-column>

    <div *dxTemplate="let itemObj of 'cellTemplate'">
      <div class="treeitem" id="image{{itemObj.data.treeElementId}}">
        <div class="container-fluid h-100">
          <div class="row h-100 d-flex">
            <!-- Image / Icon -->
            <div class="col order-0 treeitemimage d-flex align-items-center position-relative">
              <span *ngIf="!itemObj.data.imageUrl" class="glyphicon glyphicon-picture" style="font-size: 36px;"></span>
              <img *ngIf="itemObj.data.imageUrl" [src]="itemObj.data.imageUrl" style="height: 40px;"/>
              <div *ngIf="itemObj.data.type != 'cat'" class="type-indicator"
                   [ngClass]="{ 'type-pro': itemObj.data.type === 'pro', 'type-grp': itemObj.data.type === 'grp' }">
              </div>
            </div>

            <div *ngIf="showLanguageSelector && itemObj.data.type === 'cat'" class="col order-2 treeitemlanguage">
              <dx-select-box [dataSource]="languageFlags"
                             displayExpr="language"
                             valueExpr="code"
                             [value]="selectedTranslateLanguage"
                             (onValueChanged)="onLanguageChanged($event.value)"
                             fieldTemplate="field"
                             style="height: 27px; width: 37px; top: 6px;">
                <div *dxTemplate="let data of 'item'">
                  <div class="custom-item" style="margin-left: -10px;">
                    <img src="images/flags/{{data?.flag}}" class="flag"/>
                  </div>
                </div>
                <div *dxTemplate="let data of 'field'">
                  <div class="custom-item">
                    <img src="images/flags/{{data?.flag}}" class="flag"/>
                    <dx-text-box [value]="data?.text" [readOnly]="true" style="display: none"></dx-text-box>
                  </div>
                </div>
              </dx-select-box>
            </div>

            <div class="col order-1 overflow-hidden treeitemtext">
              <div class="treeitemheader">
                {{ itemObj.data.text }}
              </div>
              <div class="treeitemdetail">
                <div [ngSwitch]="itemObj.data.type">
                  <!-- CATALOG -->
                  <div *ngSwitchCase="'cat'">
                    <span *ngIf="!additionalFilter">
                      {{ 'Kategorien' | translate }}: {{ itemObj.data.categoryCount }} -
                      {{ 'Produkte' | translate }}: {{ itemObj.data.productCount }}
                      ({{ 'eindeutige' | translate }}: {{ itemObj.data.uniqueProductCount }})
                    </span>
                  </div>
                  <!-- CATEGORY -->
                  <div *ngSwitchCase="'grp'">
                    <span *ngIf="!additionalFilter">
                      {{ 'Kategorien' | translate }}: {{ itemObj.data.categoryCount }} -
                      {{ 'Produkte' | translate }}: {{ itemObj.data.productCount }}
                    </span>
                  </div>
                  <!-- PRODUCT -->
                  <div *ngSwitchCase="'pro'">
                    {{ itemObj.data.supplierPid }}
                    <i *ngIf="hasSpidFn && hasSpidFn(itemObj.data.supplierPid)"
                       class="dx-icon dx-icon-check np-icon-check"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <dx-context-menu *ngIf="showContextMenu"
                       [dataSource]="menuItems"
                       [width]="200"
                       (onShowing)="contextMenuShowing($event, itemObj)"
                       target="#image{{itemObj.data.treeElementId}}"
                       id="context{{itemObj.data.treeElementId}}"
                       (onItemClick)="contextMenuItemClick($event, itemObj)">
        <div *dxTemplate="let e of 'item'">
          <div>
            <span [ngClass]="e.icon"></span>
            <span *ngIf="e.items" class="dx-icon-spinright"></span>
            {{ e.text }}
          </div>
        </div>
      </dx-context-menu>
    </div>
  </dx-tree-list>
</div>

<div *ngIf="footerButtons?.length"
     class="catalog-tree-footer d-flex align-items-center gap-2 px-3 py-2 flex-shrink-0">
  <dx-button *ngFor="let btn of footerButtons"
             [text]="btn.text"
             [icon]="btn.icon"
             [type]="btn.type || 'default'"
             [stylingMode]="btn.stylingMode || 'contained'"
             [disabled]="btn.disabled"
             (onClick)="btn.onClick()">
  </dx-button>
</div>
